import { useLocation } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { Reveal } from "@/components/site/Motion";

const intl = (num) => num.replace(/\D/g, "").replace(/^(\d{10,11})$/, "55$1");
export const waLink = (num, text = "Olá! Vim pelo site Eutevila e gostaria de mais informações.") =>
  `https://wa.me/${intl(num)}?text=${encodeURIComponent(text)}`;
export const telLink = (num) => `tel:+${intl(num)}`;

export const WhatsAppBanner = () => {
  const { data } = useFetch("/settings/public", {});
  const num = data?.whatsapp;
  if (!num) return null;
  return (
    <section className="mx-auto max-w-[1400px] px-5 pb-8 sm:px-8" data-testid="whatsapp-banner">
      <Reveal className="grain relative overflow-hidden rounded-[2rem] bg-flash text-ink">
        <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-violet/60 blur-[100px]" />
        <div className="relative grid gap-8 p-7 sm:p-12 lg:grid-cols-12 lg:items-center">
          <div className="min-w-0 lg:col-span-7">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em]">Fale com a gente</p>
            <h2 className="mt-4 font-display text-[1.6rem] font-extrabold leading-[0.98] tracking-tight min-[420px]:text-4xl sm:text-6xl">Ligue e tenha mais informações.</h2>
            <p className="mt-4 max-w-lg text-ink/80 md:text-lg">Quer fotos no seu evento sem custo, tirar dúvidas ou encontrar suas fotos? Chame no WhatsApp.</p>
          </div>
          <div className="min-w-0 lg:col-span-5">
            <a href={telLink(num)} className="block whitespace-nowrap font-display text-[1.45rem] font-extrabold tracking-tight underline-offset-8 hover:underline sm:text-5xl lg:text-4xl xl:text-5xl" data-testid="whatsapp-banner-number">{num}</a>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href={waLink(num)} target="_blank" rel="noreferrer" data-testid="whatsapp-banner-chat-btn"
                className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-4 font-semibold text-foreground transition-transform duration-300 hover:scale-[1.03]">
                <MessageCircle className="h-5 w-5 text-flash" /> Chamar no WhatsApp
              </a>
              <a href={telLink(num)} data-testid="whatsapp-banner-call-btn"
                className="inline-flex items-center gap-2 rounded-full border-2 border-ink px-6 py-4 font-semibold transition-colors hover:bg-ink hover:text-foreground">
                <Phone className="h-5 w-5" /> Ligar agora
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export const WhatsAppFloat = () => {
  const { pathname } = useLocation();
  const { data } = useFetch("/settings/public", {});
  const num = data?.whatsapp;
  if (!num || pathname.startsWith("/eventos/") || pathname.startsWith("/pedido/")) return null;
  return (
    <a href={waLink(num)} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="whatsapp-float-btn"
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] p-4 text-ink shadow-[0_20px_50px_-15px_rgba(37,211,102,0.7)] transition-transform duration-300 hover:scale-105">
      <MessageCircle className="h-6 w-6" />
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap font-semibold transition-[max-width] duration-500 group-hover:max-w-[200px] sm:inline">Fale no WhatsApp</span>
    </a>
  );
};
